const Vue = window.Vue;
const VueRouter = require('vue-router').default;

const payRouter = new VueRouter({
    routes: [
        { 
            name: 'pay-01',
            path: '/',
            component: require('./components/pages/pay/01.vue').default 
        },
        {
            name: 'pay-02',
            path: '/02/:id',
            component: require('./components/pages/pay/02.vue').default
        },
    ],
})

Vue.component('pay-entry', require('./components/pages/pay/Index.vue').default)

if ($('#pay-app').length) { // for deposit-app
    const app = new Vue({
        router: payRouter
    }).$mount('#pay-app');
}